import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlay, FiCalendar, FiLayout, FiBarChart2, FiLayers } = FiIcons;

const SolutionShowcase = () => {
  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-gray-50">
      <div className="max-w-5xl mx-auto text-center">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-brand-navy mb-8">
            Postifyr: Your Entire Social Media Strategy in One Dashboard
          </h2>
        </motion.div>

        {/* Video Container */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="relative mb-12 group"
        >
          <a 
            href="https://www.youtube.com/watch?v=BUPOJ3TRApU" 
            target="_blank" 
            rel="noopener noreferrer"
            className="block cursor-pointer focus:outline-none focus:ring-4 focus:ring-brand-teal rounded-2xl"
            aria-label="Watch demo video on YouTube"
          >
            <div className="aspect-video bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden relative">
              {/* Fake UI for Thumbnail */}
              <div className="absolute inset-0 flex">
                {/* Sidebar */}
                <div className="w-64 bg-white border-r border-gray-100 hidden md:flex flex-col p-6 gap-4">
                  <div className="flex items-center gap-3 text-brand-teal font-bold bg-brand-teal/5 p-3 rounded-lg"><SafeIcon icon={FiLayout} /> Dashboard</div>
                  <div className="flex items-center gap-3 text-gray-500 p-3"><SafeIcon icon={FiCalendar} /> Calendar</div>
                  <div className="flex items-center gap-3 text-gray-500 p-3"><SafeIcon icon={FiBarChart2} /> Reports</div>
                  <div className="flex items-center gap-3 text-gray-500 p-3"><SafeIcon icon={FiLayers} /> Campaigns</div>
                </div>
                
                {/* Main Content */}
                <div className="flex-1 bg-gray-50 p-8">
                  <div className="flex justify-between items-center mb-8">
                    <h3 className="text-2xl font-bold text-brand-navy">Schedule Posts</h3>
                    <div className="flex gap-2">
                      <div className="px-4 py-2 bg-white border rounded-lg text-sm">Filter</div>
                      <div className="px-4 py-2 bg-brand-teal text-white rounded-lg text-sm">New Post</div>
                    </div>
                  </div>
                  
                  {/* Calendar View */}
                  <div className="grid grid-cols-3 gap-6">
                    {[1, 2, 3].map(i => (
                      <div key={i} className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
                        <div className="h-32 bg-gray-100 rounded-lg mb-4"></div>
                        <div className="h-4 bg-gray-100 rounded w-3/4 mb-2"></div>
                        <div className="flex justify-between mt-4">
                          <div className="flex gap-1">
                            <div className="w-6 h-6 rounded-full bg-pink-100"></div>
                            <div className="w-6 h-6 rounded-full bg-blue-100"></div>
                          </div>
                          <div className="text-xs text-gray-400">10:00 AM</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-brand-navy/30 group-hover:bg-brand-navy/40 transition-colors flex flex-col items-center justify-center">
                <motion.div 
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-24 h-24 bg-brand-teal rounded-full flex items-center justify-center shadow-lg shadow-brand-teal/40 mb-6"
                >
                  <SafeIcon icon={FiPlay} className="text-4xl text-white ml-2" />
                </motion.div>
                <div className="bg-black/60 px-6 py-2 rounded-full text-white font-medium backdrop-blur-sm">
                  Watch: Schedule a week of content in 8 minutes
                </div>
              </div>
            </div>
          </a>
        </motion.div>

        {/* CTA Below Video */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <a 
            href="https://dashboard.postifyr.com/rsa176125959b2e527cd97c7b79622c6fdb?ref=demo" 
            className="inline-block bg-brand-teal text-white text-lg font-bold px-10 py-4 rounded-xl hover:bg-brand-navy transition-all shadow-lg hover:shadow-xl"
          >
            Try It Free for 7 Days →
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default SolutionShowcase;